/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type JobInvoicesTab_statusTypes$ref: FragmentReference;
declare export opaque type JobInvoicesTab_statusTypes$fragmentType: JobInvoicesTab_statusTypes$ref;
export type JobInvoicesTab_statusTypes = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: JobInvoicesTab_statusTypes$ref,
|};
export type JobInvoicesTab_statusTypes$data = JobInvoicesTab_statusTypes;
export type JobInvoicesTab_statusTypes$key = {
  +$data?: JobInvoicesTab_statusTypes$data,
  +$fragmentRefs: JobInvoicesTab_statusTypes$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "JobInvoicesTab_statusTypes",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b0f69b6f6028448c0f06bae74348457d';
module.exports = node;
